import { useLocationId } from "@/Common/hooks/Location/useLocationId";
import { getDrawModalities } from "@/Settings/api/SystemSettings/queries";
import { useQuery } from "@tanstack/react-query";

export function useDrawModalities() {
	const locationId = useLocationId();

	const { data: drawModalities = [], isLoading } = useQuery({
		queryKey: ["drawModalities", locationId],
		queryFn: () => getDrawModalities(locationId),
		enabled: !!locationId,
	});

	return { drawModalities, isLoadingDrawModalities: isLoading };
}
